export const checkEmptyNumber = (value: number | null, min: number = 0) => {
  return value === null ? '' : value < min ? '' : value;
};